<template>
  <IconLucideMail />
</template>
